<template>
  <IconLucideMail />
</template>
